import React, {Fragment, useState, useEffect} from 'react';
import Header from './components/header';
import Form from './components/form';
import Lista from './components/list';
function App() {

  const[category, saveCategory] = useState('');
  const[news, saveNews] = useState([]);

  useEffect(()=>{
    const Apinews = async () => {
      const url =`http://newsapi.org/v2/top-headlines?country=co&category=${category}&apiKey=e6d8d8feb39e4699b7e5a63de75eb2bb`;

      const answer = await fetch(url);
      const noticias = await answer.json();
      saveNews(noticias.articles);
    }
    Apinews();

  },[category]);

  return (
    <Fragment>
    <Header 
      title="Noticias Colombia"
    />
    <div className="container">
      <Form 
        saveCategory={saveCategory}
      />
      <Lista
        news={news} />
    </div>
    </Fragment>
  );
}

export default App;
